import React from "react";
import { Statistic } from '../../PSY/Statistic'
import { SEVEN_DAY_APR, ONE_DAY_APR } from '../../../lexicon'

export const Info: React.FC = () => {
  return (
    <div className="bg-component border-component p-5 flex flex-col justify-between">
      <div className="text-style-value">Price</div>
      <div className="flex flex-col mt-6">
        <Statistic lexicon={SEVEN_DAY_APR} >
          N/A
        </Statistic>
        <Statistic lexicon={ONE_DAY_APR} border={false}>
          N/A
        </Statistic>
      </div>
    </div>
  );
};
